import React, { useEffect } from 'react';
import { HomePage } from './pages/HomePage';
import { MyStoryPage } from './pages/MyStoryPage';
import { ServicesPage } from './pages/ServicesPage';
import { ResultsPage } from './pages/ResultsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ContactPage } from './pages/ContactPage';
import { BookedPage } from './pages/BookedPage';
import { pages } from './data/pages';
import { usePathname } from './hooks/usePathname';
import { interceptLinkClicks, navigate } from './utils/router';
import { applyPageMeta } from './utils/seo';
export function App() {
  const pathname = usePathname();
  const meta = pages.find(page => page.path === pathname);
  useEffect(() => interceptLinkClicks(), []);
  useEffect(() => {
    // Unknown addresses fall back to the homepage URL.
    if (!meta) {
      navigate('/', {
        replace: true
      });
      return;
    }
    applyPageMeta(meta);
    // Jump links (e.g. /contact#book) handle their own scrolling.
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname, meta]);
  switch (pathname) {
    case '/my-story':
      return <MyStoryPage data-id="element-0" data-mp="3ml1397n9rmih" />;
    case '/services':
      return <ServicesPage data-id="element-1" data-mp="3mjq3diwy2ywn" />;
    case '/results':
      return <ResultsPage data-id="element-2" data-mp="3rbrbqtqzs5he" />;
    case '/resources':
      return <ResourcesPage data-id="element-3" data-mp="3rd189ei755lx" />;
    case '/contact':
      return <ContactPage data-id="element-4" data-mp="67z9oh5w26u" />;
    case '/booked':
      return <BookedPage data-id="element-5" data-mp="56qxrrj5tst" />;
    default:
      return <HomePage data-id="element-6" data-mp="2zllf11m4wkmq" />;
  }
}